<template>
  <div class="price-tag-container" :style="priceTagStyle">
    <img
      v-for="(it, idx) in conf.priceTagList"
      v-show="showIdx === idx"
      :key="idx"
      :ref="`TmPriceTag${idx}`"
      :class="['animated', {[conf.anim]: conf.anim}]"
      :src="it.priceTagSrc"
      alt=""
      width="100%"
      height="100%"
      :style="tmPriceTagStyle"
    >
  </div>
</template>

<script>
export default {
  name: 'TumengPriceTag',
  props: {
    conf: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showIdx: 0
    }
  },
  computed: {
    priceTagStyle() {
      return {
      }
    },
    tmPriceTagStyle() {
      return {
        // transform: 'rotate(' + this.conf.rotate + 'deg)',
        opacity: 1 - this.conf.transparency,
        borderRadius: this.conf.borderRadius + '%'
      }
    }
  },
  mounted() {
    const showPriceTag = () => {
      setTimeout(() => {
        this.showIdx += 1
        if (this.showIdx >= this.conf.priceTagList.length) {
          this.showIdx = 0
        }
        showPriceTag()
      }, this.conf.priceTagList[this.showIdx].duration * 1000)
    }
    showPriceTag()
  }
}
</script>

<style lang="scss" scoped>
.price-tag-container {
  width: 100%;
  height: 100%;
  > img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
